module.exports = __webpack_public_path__ + "static/media/perche-1.89ab82f1.svg";